// extracted by mini-css-extract-plugin
module.exports = {"upArrow":"Collapse_upArrow__3aLNh","downArrow":"Collapse_downArrow__274kF","upArrowIphone":"Collapse_upArrowIphone__1K7ex","downArrowIphone":"Collapse_downArrowIphone__gxlQh"};